const ACCOMMODATION_TYPE = {
  DEFAULT: 0,
  ROOM: 1,
  APARTMENT: 2,
  PITCH: 3,
  ACCOMMODATION: 4,
  VILLA: 5,
};

const AUTH_TYPE = {
  MIRAI: 1,
  SENATOR: 2,
  PESTANA: 3,
  GUESTMAKER: 4,
};

const CALENDAR_FORMAT = 'DD/MM/YYYY';

const COMPONENTS = {
  RATES: 'rates',
  CHECKOUT: 'checkout',
  BOOKING: 'booking',
};

const COOKIE = {
  CART: 'CART_COOKIE',
  PESTANA: 'pestana-login-token',
  VALUES: 'BOOKING_VALUES',
};

const ERROR = {
  NOT_AVAILABLE: 4,
  PARAMETER_ERROR: 3,
  UNKNOWN: 1,
};

const EXPERIMENT_ID = undefined;

const EVENT = {
  CORE_READY: 'core:ready',
  CORE_EVENTS_READY: 'core:events:ready',
};

const TYPE = {
  CHAIN: 'chain',
  HOTEL: 'hotel',
  GUEST: 1,
  ADULT: 2,
  CHILD: 3,
};

const TYPE_COMMISSION = {
  [TYPE.HOTEL]: '02040',
  [TYPE.CHAIN]: '02080',
};

const FINDER_STORAGE_KEY = 'MIRAI:FINDER';

const VARIANT_STORAGE_KEY = `MIRAI:EXPERIMENT:${EXPERIMENT_ID}:variant`;

const MIN_STAY_TYPE = {
  CHECK_IN: 1,
  STAY: 2,
};

const GUESTMAKER_SIGNED_IN = 'gm_loyalty_signed_in';

const GUESTMAKER_SILENT_LOGIN = 'MIRAI:GUESTMAKER:SILENT_LOGIN';

const PERFORMANCE = {
  ANALYTICS: 1,
  GOOGLE_ADS: 2,
  GTM: 3,
  MIRAI: 4,
  FACEBOOK: 5,
  THE_HOTEL_NETWORK: 6,
  AFFILIRED: 7,
  BING: 8,
  COMPARE: 9,
};

const REDIRECT_PATH = 'miraiFrontDispatcher.htm';

const SARAI_SOURCE = 'sarai';

const SENATOR_CLUB_TOKEN = 'apiData';

const SYNAPSE_COMMISSION_CODE = '07060';

const TAX_DEFAULT = 1;

const TAX_FREE = 2;

const TAX_PARTIAL = 3;

const TAXES = [TAX_DEFAULT, TAX_FREE, TAX_PARTIAL];

const TAXES_TYPE = {
  ALL_EXCLUDED: 1,
  ALL_INCLUDED: 2,
  FEES_INCLUDED: 3,
  FEES_EXCLUDED: 4,
  FEES_INCLUDED_TAXES_EXCLUDED: 5,
  TAXES_INCLUDED: 6,
  TAXES_EXCLUDED: 7,
  TAXES_INCLUDED_FEES_EXCLUDED: 8,
};

const TRACKING = {
  adwordsTracking: PERFORMANCE.GOOGLE_ADS,
  affiliredTracking: PERFORMANCE.AFFILIRED,
  analyticsTracking: PERFORMANCE.ANALYTICS,
  bingTracking: PERFORMANCE.BING,
  compareTracking: PERFORMANCE.COMPARE,
  facebookTracking: PERFORMANCE.FACEBOOK,
  gtmTracking: PERFORMANCE.GTM,
  miraiTracking: PERFORMANCE.MIRAI,
  thnTracking: PERFORMANCE.THE_HOTEL_NETWORK,
};

const VALIDATE_ERROR = {
  PRICE_CHANGED: 1,
  NOT_ENOUGH_ROOMS: 2,
  NOT_ENOUGH_ROOMS_FOR_OFFER: 3,
  NO_SELECTED_ROOMS: 4,
  EXTRA_CHANGED: 5,
  URL_GENERIC: 6,
};

const VARIANT = {
  A: 'A',
  B: 'B',
};

export {
  ACCOMMODATION_TYPE,
  AUTH_TYPE,
  CALENDAR_FORMAT,
  COMPONENTS,
  COOKIE,
  ERROR,
  EVENT,
  EXPERIMENT_ID,
  FINDER_STORAGE_KEY,
  GUESTMAKER_SIGNED_IN,
  GUESTMAKER_SILENT_LOGIN,
  MIN_STAY_TYPE,
  PERFORMANCE,
  REDIRECT_PATH,
  SARAI_SOURCE,
  SENATOR_CLUB_TOKEN,
  SYNAPSE_COMMISSION_CODE,
  TAXES,
  TAXES_TYPE,
  TAX_DEFAULT,
  TRACKING,
  TYPE,
  TYPE_COMMISSION,
  VALIDATE_ERROR,
  VARIANT,
  VARIANT_STORAGE_KEY,
};
